import React, { useEffect, useState } from "react";
import python_img from "../../../assets/images/python_img.jpg";
import { Link, useParams } from "react-router-dom";
import { axiosInstance } from "../../../config/https";
import { toast } from "react-toastify";
import { FaClock, FaWifi } from "react-icons/fa";
import { FREELANCER } from "../../../Router/paths";
import { useLoader, useModal } from "../../../context/LoaderContext";

function CoursesDetailPage() {
  const { id } = useParams();
  const { startLoader, stopLoader } = useLoader();
  const { openModal } = useModal();
  const [course, setCourse] = useState(null);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    getUserProgress(id);
    getCourses(id);
  }, [id]);

  useEffect(() => {
    if (progress === 50) {
      openModal(
        "course-progress", //gif url
        "Course Mastery Countdown!", //title
        "Remarkable progress! You're on the brink of completion, and your well-deserved reward is just within reach." //subtitle
      );
    }
    if(progress === 100){
      openModal(
        "course-complete", //gif url
        "Skill Mastery Unleashed!", //title
        "Congratulations! Course completed. Earn valuable coins as your reward. Level up your skills and boost your freelance success!" //subtitle
      );
    }
  }, [progress]);

  const getCourses = (id) => {
    startLoader();
    axiosInstance.get(`/api/courses/${id}`).then((resp) => {
      stopLoader();
      const Data = resp.data;
      if (resp.status === 200 || resp.status === 201) {
        setCourse(Data);
      } else {
        toast.warning(Data.msg);
      }
    });
  };

  const getUserProgress = (id) => {
    startLoader();
    axiosInstance.get(`/api/user-progress/progress/${id}`).then((resp) => {
      stopLoader();
      const Data = resp.data;
      if (resp.status === 200 || resp.status === 201) {
        if ((Data.watched_videos / Data.total_videos) * 100 === Infinity)
          return setProgress(0);
        setProgress((Data.watched_videos / Data.total_videos) * 100);
      } else {
        toast.warning(Data.msg);
      }
    });
  };

  return (
    <div>
      <div className="course-sec pc-p-3">
        <div className="container-fluid px-5">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="progress mb-3">
                <div
                  className="progress-bar"
                  role="progressbar"
                  style={{
                    width: `${progress}%`,
                    ariaValuenow: progress,
                    ariaValuemin: 0,
                    ariaValuemax: 100,
                  }}
                >
                  {progress.toFixed(1)}%
                </div>
              </div>
              <div className="course-box">
                <div className="course-img">
                  <img src={python_img} alt="Python" />
                </div>
                <div className="course-box-content">
                  {/* <h5>Technology</h5> */}
                  <h4 className="text-capitalize">
                    <a href="javascript:void(0)"> {course?.title} </a>
                  </h4>
                  <div className="course-hour-box">
                    <span>
                      <FaClock /> {course?.total_duration} Hour
                    </span>
                    <span>
                      <FaWifi /> {course?.level}
                    </span>
                  </div>
                </div>
              </div>
              <div className="course-box p-3">
                <div className="primary-heading color-dark">
                  <p style={{textAlign: 'justify'}}>{course?.description}</p>
                </div>
                <Link
                  to={FREELANCER.viewLecture(id)}
                  className="primary-btn primary-bg"
                >
                  Start Course
                </Link>
              </div>
            </div>
            {/* <div className="col-lg-3">
              <div className="course-box">
                <div className="course-img">
                  <img src={python_img} alt="Python" />
                </div>
                <div className="course-box-content">
                  <h4>
                    <a href="javascript:void(0)"> Basics of Python </a>
                  </h4>
                  <div className="course-hour-box">
                    <span>
                      <FaClock /> 1 Hour
                    </span>
                    <span>
                      <FaWifi /> Beginner
                    </span>
                  </div>
                </div>
              </div>
              <div className="course-box">
                <div className="course-img">
                  <img src={python_img} alt="Python" />
                </div>
                <div className="course-box-content">
                  <h4>
                    <a href="javascript:void(0)"> Basics of Python </a>
                  </h4>
                  <div className="course-hour-box">
                    <span>
                      <FaClock /> 1 Hour
                    </span>
                    <span>
                      <FaWifi /> Beginner
                    </span>
                  </div>
                </div>
              </div>
              <div className="course-box">
                <div className="course-img">
                  <img src={python_img} alt="Python" />
                </div>
                <div className="course-box-content">
                  <h4>
                    <a href="javascript:void(0)"> Basics of Python </a>
                  </h4>
                  <div className="course-hour-box">
                    <span>
                      <FaClock /> 1 Hour
                    </span>
                    <span>
                      <FaWifi /> Beginner
                    </span>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CoursesDetailPage;
